// Shared number/currency formatters for the Portfolio v2 components.
export const fmt$ = (n, d = 0) =>
  n == null || isNaN(n) ? '—'
    : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: d, maximumFractionDigits: d }).format(n);

export const signed$ = (n, d = 0) => (n == null || isNaN(n) ? '—' : `${n >= 0 ? '+' : ''}${fmt$(n, d)}`);

export const fmtNum = (n, d = 0) =>
  n == null || isNaN(n) ? '—' : Number(n).toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });

// Quantity: whole numbers show 0 decimals, fractional shares show `d` decimals.
export const fmtQty = (n, d = 2) => (n == null || isNaN(n) ? '—' : fmtNum(n, Math.abs(n % 1) > 1e-6 ? d : 0));

export const pnlClr = (n) =>
  n == null || isNaN(n) ? 'text-gray-400' : n > 0 ? 'text-green-400' : n < 0 ? 'text-red-400' : 'text-gray-400';
